import { computed, onMounted } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { useStoreGetters } from 'dashboard/composables/store';

/**
 * Composable untuk mengecek status integrasi Cetakers Flow.
 *
 * Mengembalikan `isCetakersFlowEnabled` yang bernilai `true` hanya jika:
 * 1. Feature flag 'cetakers_flow' diaktifkan oleh Superadmin untuk akun ini, DAN
 * 2. Admin akun sudah menyambungkan API Key via menu Integrasi (ada hook yang tersimpan).
 */
export function useCetakersFlow() {
  const store = useStore();
  const currentAccountId = useMapGetter('getCurrentAccountId');
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );
  const getters = useStoreGetters();

  const isFeatureFlagOn = computed(() =>
    isFeatureEnabledonAccount.value(currentAccountId.value, 'cetakers_flow')
  );

  const cetakersIntegration = computed(() => {
    const apps = getters['integrations/getAppIntegrations'].value;
    return apps?.find(app => app.id === 'cetakers_flow');
  });

  const isConnected = computed(
    () => !!(cetakersIntegration.value?.hooks?.length > 0)
  );

  const isCetakersFlowEnabled = computed(
    () => isFeatureFlagOn.value && isConnected.value
  );

  onMounted(() => {
    if (isFeatureFlagOn.value) {
      store.dispatch('integrations/get');
    }
  });

  return {
    isCetakersFlowEnabled,
    isFeatureFlagOn,
    isConnected,
  };
}
